module.exports = __webpack_public_path__ + "img/green-play.851d80ce.svg";